import { render, staticRenderFns } from "./createReferProductDialog.vue?vue&type=template&id=abf67bc2&scoped=true"
import script from "./createReferProductDialog.vue?vue&type=script&lang=js"
export * from "./createReferProductDialog.vue?vue&type=script&lang=js"
import style0 from "./createReferProductDialog.vue?vue&type=style&index=0&id=abf67bc2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf67bc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abf67bc2')) {
      api.createRecord('abf67bc2', component.options)
    } else {
      api.reload('abf67bc2', component.options)
    }
    module.hot.accept("./createReferProductDialog.vue?vue&type=template&id=abf67bc2&scoped=true", function () {
      api.rerender('abf67bc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/addProductDialog/createReferProductDialog.vue"
export default component.exports